import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PaperToastStackComponent } from '@ricoh-paper/angular';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PaperToastStackComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <router-outlet />
    <paper-toast-stack />
  `,
})
export class App {}
